import {connect} from 'react-redux';

import {makeMapDispatchToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {CardModel} from '../../../../models/api/cardModel';
import {popoutContactDetailsAction} from '../../../../store/panels/contacts/contactDetailsPanelActions';
import {ContactOrAccountDetailsPanelId} from '../../../../store/panels/panelStateBase';
import {AccountDetailsContact} from './accountDetailsContact';

/*
 * Props.
 */

interface AccountDetailsContactContainerProps {
  card?: CardModel;
  panelId: ContactOrAccountDetailsPanelId;
}

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps<AccountDetailsContactContainerProps>()((props) => ({
  openContactDetailsPopUp: () =>
    popoutContactDetailsAction({
      parentPanelId: props.panelId,
      selectedCardId: props.card?.id,
      shouldHideHeaderTabs: true,
    }),
}));

export const AccountDetailsContactContainer = connect(null, mapDispatchToProps)(AccountDetailsContact);
